/**
 * Datas oficiais de legislação (publicação, vigência, ato) são dias de calendário,
 * não instantes. Formata sem deslocar por fuso (evita d-1 em America/Sao_Paulo).
 */
export function officialDateKey(value: string | null | undefined): string | null {
  if (!value) return null;
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
}

export function formatOfficialDateBR(value: string | null | undefined): string {
  const key = officialDateKey(value);
  if (!key) return '';
  const [year, month, day] = key.split('-');
  return `${day}/${month}/${year}`;
}

/** Hoje no calendário UTC (alinha com datas oficiais gravadas ao meio-dia UTC). */
export function todayOfficialDateKey(): string {
  const now = new Date();
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
    .toISOString()
    .slice(0, 10);
}

/** Soma dias no calendário UTC (YYYY-MM-DD). */
export function addOfficialDaysISO(baseISO: string, deltaDays: number): string {
  const key = officialDateKey(baseISO) || todayOfficialDateKey();
  const [year, month, day] = key.split('-').map(Number);
  const dt = new Date(Date.UTC(year, month - 1, day));
  dt.setUTCDate(dt.getUTCDate() + deltaDays);
  return dt.toISOString().slice(0, 10);
}

/** dd/mm para eixos de gráfico. */
export function formatOfficialDateShortBR(value: string | null | undefined): string {
  const key = officialDateKey(value);
  if (!key) return '';
  const [, month, day] = key.split('-');
  return `${day}/${month}`;
}

export function formatOfficialDateLongBR(value: string | null | undefined): string {
  const key = officialDateKey(value);
  if (!key) return '';
  const [year, month, day] = key.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  return d.toLocaleDateString('pt-BR', {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
